import { Component, OnInit } from '@angular/core';
import { faStar } from '@fortawesome/free-regular-svg-icons';
import { faStar as faStarFull } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-favorite',
  templateUrl: './favorite.component.html',
  styleUrls: ['./favorite.component.scss']
})
export class FavoriteComponent implements OnInit {

  faStar = faStar;
  faStarFull = faStarFull;
  isFavorite = true;

  constructor() { }

  ngOnInit(): void {
  }

  getFavorite(): void {
    this.isFavorite = !this.isFavorite;
  }

}
